import { IWorkerService } from '../../models/worker-service.model';

/**
 *
 */
export function flexServices(): Array<IWorkerService> {
  return [
    {
      id: 'basic_transport',
      name: 'Provide transport',
      isImportant: true,
      information: {
        definition: `<span>The support worker will provide transport using their car or the client's car.</span>`,
        additionalText: `<span>The support worker's driver licence was verified only when uploaded to Mable.
          Check the driver still holds a valid Australian driver licence and that the vehicle is registered and covered by comprehensive insurance.</span>`,
      },
    },
    {
      id: 'basic_assist_med',
      name: 'Assist with medication',
      isImportant: true,
      information: {
        definition: `<p><span>Assistance with self-medication</span></p>
          <br />
          <p><span>Limited to:</span></p>
          <ul>
            <li>
              <span
                >Identifying the right person and verifying that the name on blister
                pack matches who is being given the blister pack.&nbsp;<span
                  >All tablets should be in blister packs.</span
                ></span
              >
            </li>
          </ul>
          <ul>
            <li><span>Prompting by handing pack to the person to pop out.</span></li>
            <li><span>Prompting verbally, e.g. reminding the person to take the medicine.</span></li>
            <li>
              <span
                >Can assist by popping tablets out of blister into container and handing
                to person.</span
              >
            </li>
            <li>
              <span
                >If liquids, the person needs to be able to pour liquid or identify
                correct dose in medicine glass.</span
              >
            </li>
            <li><span>No injections.</span></li>
          </ul>
          <p><br /></p>
          <p>
            <span
              >If the person requires additional services related to taking medication
              they will need to engage someone qualified to offer “Medication
              management” services.</span
            >
          </p>`,
      },
    },
    {
      id: 'basic_manual_handling',
      name: 'Manual transfer and mobility',
      isImportant: true,
      information: {
        definition: `
          <p><strong>Manual transfer and mobility</strong></p>
          <p>
            <span
              >Provide physical assistance to stand, sit, or change position, and
              lifting safely.</span
            >
          </p>
          <p><br /></p>
          <p><strong>Hoist and transfer</strong></p>
          <p>
            <span
              ><span>Using lifting equipment to transfer someone’s position</span></span
            >
          </p>
          <p><br /></p>
          <p>
            <span>
              <span>
                <span>
                  Support workers providing this service must have undertaken the
                  appropriate training.
                </span>
              </span>
            </span>
          </p>`,
      },
    },
    {
      id: 'basic_showering',
      name: 'Showering, toileting and dressing',
      isImportant: true,
      information: {
        definition: `
          <p>
            <strong><span>Showering, dressing, grooming</span></strong>
          </p>
          <p>
            <span
              >Assisting a person to shower or bathe, getting dressed, and general
              grooming.&nbsp;</span
            >
          </p>
          <p><br /></p>
          <p>
            <strong><span style="color: rgb(9,30,66);">Toileting</span></strong>
          </p>
          <p>
            <span><span>Assistance in using a toilet or incontinence aids.</span></span>
          </p>`,
      },
    },
  ];
}

/**
 *
 */
export function basicSearchFilters(): Array<IWorkerService> {
  const services: Array<IWorkerService> = [
    {
      id: 'basic_companionship',
      name: 'Companionship and social support',
      isImportant: false,
      information: {
        definition: '<p>Social support for a person in their home or in the community.<p>',
      },
    },
    {
      id: 'basic_community',
      name: 'Community participation, sports and activities',
      isImportant: false,
      information: {
        definition: `<p>
          <span
            >Accompanying a person to activities of their choice, including social or
            community related activities.
          </span>
        </p>
        <p>
          <br />
        </p>
        <p>
          <span
            >Assisting a person with community sports, fitness, and daily
            exercise.</span
          >
        </p>`,
      },
    },
    flexServices()[0],
    {
      id: 'basic_meal',
      name: 'Meal delivery, preparation and shopping',
      isImportant: false,
      information: {
        definition: '<span>Assistance with meal preparation.</span>',
        additionalText: `
          <span>
          This does NOT include preparing meals for people with swallowing or chewing requirements or complex diets.
          </span>`,
      },
    },
    {
      id: 'basic_housework',
      name: 'Light housework',
      isImportant: false,
      information: {
        definition: `<span>
          Light housework, including vacuuming, dusting, laundry, cleaning bathrooms and toilets, and washing floors.
          </span>`,
      },
    },
    flexServices()[3],
    flexServices()[2],
    flexServices()[1],
    {
      id: 'basic_nurse',
      name: 'Nursing services',
      isImportant: true,
      information: {
        definition: '<p>Services provided by an enrolled or registered nurse.</p>',
        additionalText: ` <p>This includes:</p>
          <ul>
            <li>Wound care</li>
            <li>Palliative nursing care</li>
            <li>Catheter care</li>
            <li>Medication management</li>
            <li>Continence assessment and management</li>
            <li>Case assessment and management</li>
            <li>Vital signs monitoring</li>
            <li>Respiratory care</li>
            <li>Pre and post-acute hospital care</li>
          </ul>`,
      },
    },
    {
      id: 'basic_allied',
      name: 'Allied health services',
      isImportant: true,
      information: {
        definition: '<p>Services provided by an allied health professional.</p>',
        additionalText: ` <p>This includes:</p>
          <ul>
            <li>Occupational therapy</li>
            <li>Psychological services</li>
            <li>Physiotherapy</li>
            <li>Speech therapy/pathology</li>
          </ul>`,
      },
    },
  ];
  return services;
}
